export default __webpack_public_path__ + "static/media/platformDeviceIcon4.72321d48.webp";